export default "__VITE_ASSET__Cej9EPS3__"